import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Distributor } from '../../models/distributor';
import { DistributorsService } from '../services/distributors.service';

@Injectable()
export class DistributorsResolver implements Resolve<Distributor[]>
{
	private distributorsService: DistributorsService;

	constructor(distributorsService: DistributorsService)
	{
		this.distributorsService = distributorsService;
	}

	resolve(): Promise<Distributor[]>
	{
		return this.distributorsService.getDistributors();
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/resolvers/distributors.resolver.ts